<template>
    <div :class="classObj" class="app-wrapper">
        <!-- <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    /> -->
        <div :class="{ 'fixed-header': fixedHeader }">
            <navbar />
        </div>
        <sidebar class="sidebar-container" v-if="applyStatus == 2" />
        <div :class="[needTagsView ? 'hasTagsView' : '', applyStatus != 2 ? 'mg_left' : '']" class="main-container" style="padding-top: 90px">
            <div
                v-if="applyStatus == 2"
                class="tages"
                :style="{
                    width: isCollapse ? 'calc(100% - 210px)' : 'calc(100% - 50px)',
                    left: isCollapse ? '230px' : '100px',
                }">
                <tags-view v-if="needTagsView" />
            </div>

            <app-main />
        </div>
    </div>
</template>

<script>
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { mapState } from 'vuex';
export default {
    name: 'Layout',
    components: {
        AppMain,
        Navbar,
        Settings,
        Sidebar,
        TagsView,
    },
    data() {
        return {
            applyStatus: -1,
        };
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapState({
            sidebar: (state) => state.app.sidebar,
            device: (state) => state.app.device,
            showSettings: (state) => state.settings.showSettings,
            needTagsView: (state) => state.settings.tagsView,
            fixedHeader: (state) => state.settings.fixedHeader,
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile',
            };
        },
        isCollapse() {
            return this.sidebar.opened;
        },
    },
    created() {
        this.applyStatus = this.$store.state.user.applyStatus;
    },
    methods: {
        handleClickOutside() {
            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.tages {
    position: fixed;
    top: 50px;
    z-index: 1002;
}
.mg_left {
    margin-left: 0 !important;
}
.sidebar-container {
    padding-top: 50px;
    background-color: #f7f8f9; // background-color: #f2f2f2;
}

.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}

.drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
}

.fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1002;
    width: 100%;
    // width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
}

.hideSidebar .fixed-header {
    width: 100%;
}

.mobile .fixed-header {
    width: 100%;
}
</style>
